import React from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import resources from "../../lang/resources";
import { getName } from "country-list";
import { formatCurrency } from "./shared/formatCurrency";

export const SeoSearchProfile = ({ user }) => {
  const { t } = useTranslation();

  const guiltyPerson = () => {
    return user.first_name && user.last_name
  }

  const personalizedTitle = () => {
    return guiltyPerson() ? `${user.first_name} ${user.last_name} | Crypto ${t('scam')} | ID:${user.id} | Billions Trade Club` : `${t('search_title')} | ID:${user.id} | Crypto ${t('scam')}`
  }

  const personalizedDesc = () => {
    return guiltyPerson() ? `${t('search_description')} ${user.first_name} ${user.last_name}. ID:${user.id}. ${t('invested')}: ${formatCurrency(user.invested)}. ${t('withdrawn')}: ${formatCurrency(user.withdrawn)}.` : `${t('search_description')}. ID:${user.id}. Pyramid Level: ${user.level}.`
  }

  const personalizedKeywords = () => {
    const firstNamePart = user.first_name ? user.first_name.split(" ")[0] : "";
    const lastNamePart = user.last_name ? user.last_name.split(" ")[0] : "";
    return guiltyPerson() ? `${user.first_name} ${user.last_name}, ${firstNamePart} ${lastNamePart}, ${user.first_name}, ${user.last_name}, ${user.first_name} ${user.last_name} ${getName(user.country_code)}` : t('btc_keyword')
  }

  // Languages availables from project
  const availablesLanguages = ["x-default", ...Object.keys(resources)];

  const getLanguageCode = () => {
    const locale = new Intl.Locale('und', { region: user.country_code || "US" });
    const detectedLanguage = locale.maximize().language;
    // Check if the detected language is in the list of valid languages
    // If not, return the default language (English)
    return availablesLanguages.includes(detectedLanguage) ? detectedLanguage : "en";
  }

  return (
    <Helmet>
      <title>{personalizedTitle()}</title>
      <link rel="canonical" href={`https://ponzilover.com/${getLanguageCode()}/search/${user.id}`} />
      {availablesLanguages
        .map((lang) => {
          return (
            <link
              key={lang}
              rel="alternate"
              hrefLang={lang}
              href={lang === "x-default" ? `https://ponzilover.com/${getLanguageCode()}/search/${user.id}` : `https://ponzilover.com/${lang}/search/${user.id}`}
            />
          );
        })
      }
      <meta name="description" content={personalizedDesc()} />
      <meta name="robots" content="index, follow" />
      <meta name="keywords" content={personalizedKeywords()} />
      <meta property="og:title" content={personalizedTitle()} />
      <meta property="og:description" content={personalizedDesc()} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={window.location.href} />
    </Helmet>
  );
};
